module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RBrj5f/tc-custom/9781426861598.jpg?1718106414113",
      "alt": "This image is the cover for the book Duke's Desire"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Duke's Desire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("She'd fled the bed of the duke of Deighton and returned to her life of quiet respectability. But VerityDavis-Jones could never forget Galen Bromney, \"her\" notorious duke,for she saw him daily in the face of their child—the daughter shemust deny him, along with her heartfelt love!Ten years of self-imposed exile had done little to dissuade GalenBromney of the rightness of being with Verity. Yet how would he everconvince the woman of his dreams that a life together raising theirdaughter was his deepest desire?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Margaret Moore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Margaret Moore actually began her writing career at the age of eight, when she and a friend would make up stories together. She also loved to read and many years later graduated with a Bachelor of Arts degree in English Literature. After reading a romance by Kathleen Woodiwiss, Margaret took a course in popular fiction writing and through that, found Romance Writers of America. Three years later, in 1991, she sold her first historical romance. And the rest, as they say, is history!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0